import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import Alert from "@material-ui/lab/Alert";
import Typography from "@material-ui/core/Typography";
import { IAssessment, IAssessmentProject, IAssessmentTemplateGroup } from "../types/types";
import {
    Accordion,
    AccordionSummary, Chip, ClickAwayListener,
    Divider, Grow, IconButton, MenuItem,Button,
    Paper, Popper, Toolbar
} from "@material-ui/core";


import ViewModuleIcon from '@material-ui/icons/ViewModule';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SettingsIcon from '@material-ui/icons/Settings';
import CircularProgress from "@material-ui/core/CircularProgress";
import { CloudDownload, ExitToApp, ExpandMore } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { APPLICATION } from "../env";;

interface IToolBarProps {
    title: string
}

interface IRouteParams {
    id: string
    state?: string
}


const { REACT_APP_BRANCH } = process.env;



const SFIARPToolbar: FC<IToolBarProps> = ({ title} : IToolBarProps ) => {

    const history = useHistory();
    const [popperOpen, setPopperOpen] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    // get user from local storage
    const username = localStorage.getItem("username");

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        history.push('/');
        window.location.reload();
    };

    const renderNavMenu = () => {
        return <Popper
            style={{ zIndex: 100 }}
            open={popperOpen}
            anchorEl={anchorEl}

            placement={"bottom-end"} disablePortal transition>
            {({ TransitionProps }) => (
                <Grow {...TransitionProps}>
                    <Paper>
                        <ClickAwayListener onClickAway={_ => setPopperOpen(false)}>
                            <div>
                                <MenuItem><AccountCircleIcon style={{ marginLeft: "-10px", paddingRight: "10px" }} />Account</MenuItem>
                                <MenuItem onClick={_ => handleLogout()}><ExitToApp style={{ marginLeft: "-10px", paddingRight: "10px" }} />Logout</MenuItem>
                            </div>
                        </ClickAwayListener>
                    </Paper>
                </Grow>)}
        </Popper>
    }

    return (<div>
        <Toolbar style={{ backgroundColor: "#19b0ef", height: "68px", color: "white" }}>


            {APPLICATION == "SFAIRP" &&

            <Typography variant={"h5"}
                style={{ paddingTop: "7px", paddingBottom: "7px" }}>
                SFAIRP | {title}
            </Typography>}

            {APPLICATION == "ALARP" &&

            <Typography variant={"h5"}
                style={{ paddingTop: "7px", paddingBottom: "7px" }}>
                ALARP | {title}
            </Typography>}

            <div style={{ position: "fixed", right: "10px", marginTop: "-3px", }}>
                {username}


                <IconButton color="inherit" onClick={(e) => {
                    setPopperOpen(!popperOpen);
                    setAnchorEl(e.currentTarget)
                }

                }><MoreVertIcon /></IconButton></div>
            {renderNavMenu()}

            {/* {showSettings && < ProjectSettings closeDialogCallback={addDialogShowSettingsCallback} />}
            {showStates && < States closeDialogCallback={addDialogShowStatesCallback} />} */}
        </Toolbar>

        {REACT_APP_BRANCH !== 'main' ?  <Alert variant="filled" severity="warning">
                This is a development version, the data displayed may not be accurate and updates to the data will not be stored.
            </Alert> : null}

        {REACT_APP_BRANCH === 'demo' ? <Alert variant="filled" severity="warning">
            This is a demo version, with typical kinds of assessments it does not purport to represent any actual dam.
        </Alert> : null}

    </div>)
}

export default SFIARPToolbar